import { useDesktopWidth } from "../hooks/useDesktopWidth";

export const withDesktopWidth = (Component) => {
  return (props) => {
    const isDesktopWidth = useDesktopWidth();
    return <Component isDesktopWidth={isDesktopWidth} {...props} />;
  };
};